import { render, staticRenderFns } from "./PBRMappingList.vue?vue&type=template&id=3671649c&"
import script from "./PBRMappingList.vue?vue&type=script&lang=js&"
export * from "./PBRMappingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports